import React, { Fragment, useEffect, useState } from 'react';
import { styled, lighten } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { updateContact } from 'services/contacts.service';
import toast from 'utils/toast';
import Spin from 'components/Spin';

const Root = styled(Box)`
  min-height: 100vh;
  background-color: ${({ theme }) =>
    lighten(theme.palette.background.navbar, 0.1)};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  .logo {
    max-height: 100px;
    max-width: 300px;
    padding-top: 30px;
    margin-bottom: 10%;
    img {
      width: 100%;
    }
  }
`;

const Unsubscribe = ({ location, history }) => {
  const [t] = useTranslation('checkout');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const q = qs.parse(location.search.substr(1));
    if (!q.id) {
      return history.push('/');
    }
    updateContact(q.id, {
      contact_optout_email: '1',
      contact_source: 'Email Unsubscribe',
    })
      .then(() => {
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e.message);
      });
  }, []);
  return (
    <Root>
      <Helmet>
        <title>Unsubscribe</title>
      </Helmet>
      <Container>
        <div className="logo">
          <img src={t('logo-image')} />
        </div>
        <Grid container spacing={2}>
          <Grid item md={10}>
            <Spin spinning={loading}>
              <Typography color="inherit" variant="h1">
                Unsubscribed
              </Typography>
              <Typography color="inherit">
                We are sorry to see you go! You have been immediately
                unsubscribed and you will not receive any more emails.
              </Typography>
            </Spin>
          </Grid>
        </Grid>
      </Container>
    </Root>
  );
};

export default Unsubscribe;
